export default __webpack_public_path__ + "static/media/Nico Wilhelm.9ce1b1ec.png";